<template>
  <NavBar />
  <router-view />
  <Footer />
</template>

<script>
import { RouterView } from 'vue-router' // Import RouterView from vue-router
import NavBar from './components/NavBar.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    RouterView,
    Footer,
  },
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $brand-black;
}
</style>
